function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { observe } from "../../../utils/web-vitals/lib/observe";
import { sendAsyncMetric } from '.';
import { fix } from "../../utils";
var n = 0;
var longTasks = [];
var curIndex = 0;
export var getLongTaskEntries = function getLongTaskEntries() {
  return longTasks;
};
export var clearLongTaskQueue = function clearLongTaskQueue() {
  longTasks = [];
};
export function startLongTasks(taskRef) {
  var _PerformanceObserver;
  var ctx = taskRef.value.ctx;
  var _ref = ctx.options || {},
    _ref$longtaskDuration = _ref.longtaskDurationThreshold,
    longtaskDurationThreshold = _ref$longtaskDuration === void 0 ? 200 : _ref$longtaskDuration;
  var entryHandler = function entryHandler(entries) {
    var res = [];
    var _iterator = _createForOfIteratorHelper(entries),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var entry = _step.value;
        var startTime = fix(entry.startTime);
        var duration = fix(entry.duration);
        var endTime = fix(startTime + duration);
        var longtask = {
          name: "longtask-".concat(++n),
          timestamp: Date.now(),
          startTime: startTime,
          endTime: endTime,
          duration: duration
        };

        // longTasks.push(longtask)
        if (duration >= longtaskDurationThreshold) {
          var val = "".concat(longtask.timestamp, "|").concat(longtask.name, "|").concat(longtask.startTime, "|").concat(longtask.duration, "|").concat(longtask.endTime);
          res.push(val);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (!res.length) return;
    sendAsyncMetric(taskRef.value, {
      type: 'longtask',
      value: res
    });
  };
  if ((_PerformanceObserver = PerformanceObserver) !== null && _PerformanceObserver !== void 0 && (_PerformanceObserver = _PerformanceObserver.supportedEntryTypes) !== null && _PerformanceObserver !== void 0 && _PerformanceObserver.includes('longtask')) {
    observe('longtask', entryHandler);
  }
}